import React from 'react';
import Select, { SelectProps } from 'antd/lib/select';

export const CloudVenDispatchTypeMethodSelect = (props: SelectProps<string>) => {
    return (
        <Select
            allowClear
            size="large"
            placeholder="Select Dispatch By Method"
            options={[
                { label: 'Program', value: 'program' },
                { label: 'Site', value: 'site' },
                { label: 'Resource ID', value: 'resource_id' },
                { label: 'Group ID', value: 'group_id' },
            ]}
            {...props}
        />
    );
};

export const CloudVenDispatchTypeTableLabelMap: Record<string, string> = {
    program: 'by Program',
    site: 'by Site',
    resource_id: 'by Resource ID',
    group_id: 'by Group ID',
};
